module.exports = __webpack_public_path__ + "static/media/FqafoxCaUAAPj1S.8aa6fe33.webp";